import { render, staticRenderFns } from "./aiVideoProduction.vue?vue&type=template&id=57a21e54&lang=html&"
import script from "./aiVideoProduction.vue?vue&type=script&lang=js&"
export * from "./aiVideoProduction.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/service.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "aiVideoProduction.vue"
export default component.exports